import '@lottiefiles/lottie-player'

export default function LoadingView({ isLoading }) {
  return isLoading ? (
    <lottie-player
      autoplay
      loop
      style={{ width: '300px', height: '300px', margin: '5% auto' }}
      src="https://assets6.lottiefiles.com/packages/lf20_u98PhF.json"
      speed="1"
    ></lottie-player>
  ) : (
    <></>
  )
}
